/**
 * @fileoverview Detection utilities index.
 *
 * This module exports all detection-related utilities including project type
 * and framework detection.
 */

export * from './frameworkDetector';
export { detectPrimaryLanguage } from './frameworkDetector';
export * from './projectTypeDetector';
